import React from "react";
import { useSpring } from "react-spring";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { FaWifi, FaDesktop, FaRegClock } from 'react-icons/fa';
import Adobe from "../assets/images/Adobe.png";
import Banner from "../assets/images/hero-banner.jpg";
import BrandImg from "../assets/images/brand2.png";
import Amazon from "../assets/images/Amazon.png";
import Microsoft from "../assets/images/Microsoft.png";
import Urban from "../assets/images/Urban.png";
import Zomoto from "../assets/images/Zomoto.png";
import BankingImg from "../assets/icons/Banking.png";
import BPOImg from "../assets/icons/BPO.png";
import ConsultingImg from "../assets/icons/Consulting.png";
import HumanImg from "../assets/icons/Human.png";
import ITImg from "../assets/icons/IT.png";
import LegalImg from "../assets/icons/Legal.png";
import OperationsImg from "../assets/icons/Operations.png";
import SalesImg from "../assets/icons/Sales.png";
import Footer from '../Footer/Footer';


const LandingPage = () => {
  const animationProps = useSpring({ opacity: 1, from: { opacity: 0 } });

  // Browse by Category Cards
  const cardsData = [
    { title: "Banking & Finance", imgUrl: BankingImg, className: "bg-white p-5 min-card" },
    { title: "BPO", imgUrl: BPOImg, className: "bg-white p-5 min-card" },
    { title: "Consulting", imgUrl: ConsultingImg, className: "bg-white p-5 min-card" },
    { title: "Human Resources", imgUrl: HumanImg, className: "bg-white p-5 min-card" },
    { title: "IT & Systems", imgUrl: ITImg, className: "bg-white p-5 min-card" },
    { title: "Legal", imgUrl: LegalImg, className: "bg-white p-5 min-card" },
    { title: "Operations", imgUrl: OperationsImg, className: "bg-white p-5 min-card" },
    { title: "Sales & Marketing", imgUrl: SalesImg, className: "bg-white p-5 min-card" },
  ];

  const cardsData2 = [
    { title: "01", description: "Register your account", className: "bg-light px-5 py-3" },
    { title: "02", description: "Apply for the job", className: "bg-skyblue px-5 py-3" },
    { title: "03", description: "Upload your resume", className: "bg-lipink px-5 py-3" },
    { title: "04", description: "Scheduled Interviews", className: "bg-liyellow px-5 py-3" },
  ];


  const jobsType = [
    { imgUrl: <FaWifi />, title: 'Remote Jobs', count: '2,920', className: 'text-primary' },
    { imgUrl: <FaDesktop />, title: 'Fulltime Jobs', count: '3,810', className: 'text-secondary' },
    { imgUrl: <FaRegClock />, title: 'Parttime Jobs', count: '1,258', className: 'text-success' },
  ];


  const badgeRow = [
    { badgetext: 'Freshers' },
    { badgetext: 'HR Executive' },
    { badgetext: 'Manual Testing' },
    { badgetext: 'Software Engineer' },
    { badgetext: 'Comapany Analyst' },
    { badgetext: 'DevOps Engineer' },
    { badgetext: 'Data Analyst' },
    { badgetext: 'Digital Marketing' },
    { badgetext: 'Banking' },
    { badgetext: 'UX/UI' },
  ];

  return (
<>
    <div className="bg-white js-banner mt-5 pt-5">
      <div className="vertical-gradient py-5">
        <div className="container py-5 py-lg-5">
            <div className="row py-4 align-items-center justify-content-center">
                <div className="col-md-6 col-lg-6 col-xl-6 text-start mb-4 pe-5 px-lg-2">
                  <span className="text-primary fs-4"> </span>
                  <h1 className="display-5 fw-600 my-3">Find the perfect service provider</h1>
                  <p className="mb-4 w-75 pt-3 fs-5">
                  Search, compare, and decide on a service provider in no time—powered by verified reviews from real Comapany leaders.
                  </p>

                </div>
                <div className="col-md-6 col-lg-6 col-xl-6">
                <img src={Banner} className="img-fluid" alt="LeadStream" title="LeadStream" width={700} />
                </div>
            </div>
        </div>
      </div>

      {/* For Companies */}
      <div className="container pb-5">
        <div className="row align-items-center">
          <div className="col-md-10 mx-auto mb-5">
            <h2 className="text-center display-6 mb-4 fw-semibold">Join leaders on <span className="border-line">LeadStream</span> to connect with trusted Comapany partners.</h2>
          </div>
          <div className="col-md-12 mb-4 text-center">
            <Swiper
              spaceBetween={50}
              slidesPerView={5}
              centeredSlides={false}
              loop={true}
              aria-live="off"
              style={{ transitionDuration: "0ms", transform: "translate3d(-0px, 0px, 0px)" }}
              breakpoints={{
                320: { // Mobile devices
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                640: { // Tablets and up
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                1024: { // Desktops and up
                  slidesPerView: 5,
                  spaceBetween: 50,
                },
              }}
            >
              <SwiperSlide aria-label="1 / 6" style={{ width: "160px", height: "60px", marginRight: "50px" }}>
                <img src={Adobe} alt="Adobe Image" />
              </SwiperSlide>
              <SwiperSlide aria-label="2 / 6" style={{ width: "160px", marginRight: "60px" }}>
                <img src={Amazon} alt="Amazon Image" />
              </SwiperSlide>
              <SwiperSlide aria-label="3 / 6" style={{ width: "160px", marginRight: "60px" }}>
                <img src={Microsoft} alt="Microsoft Image" />
              </SwiperSlide>
              <SwiperSlide aria-label="4 / 6" style={{ width: "160px", marginRight: "60px" }}>
                <img src={Urban} alt="Urban Image" />
              </SwiperSlide>
              <SwiperSlide aria-label="5 / 6" style={{ width: "160px",  height: "60px", marginRight: "50px" }}>
                <img src={Zomoto} alt="Zomoto Image" />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>

      <div className="pg_bg mt-4">
        <div className="container">
          <div className="d-lg-flex d-sm-block py-5 justify-content-around">
            <div className="text-center py-4">
              <h3 className="display-3 fw-600 text-white">15K+</h3>
              <p className="text-white fs-5">Trusted Companies</p>
            </div>
            <div className="text-center py-4">
              <h3  className="display-3 fw-600 text-white">500+</h3>
              <p className="text-white fs-5">Verified Service Providers</p>
            </div>
            <div className="text-center py-4">
              <h3  className="display-3 fw-600 text-white">15+</h3>
              <p className="text-white fs-5">Countries are in Service</p>
            </div>
          </div>
        </div>

      </div>


      <div className="bg-light py-5">
  <div className="container-md py-5">
    <div className="justify-content-center text-center row">
      <div className="col-lg-12 col-xl-10">
        <h2 className="text-center display-6 fw-semibold">Browse services by category</h2>
        <p className="fs-5 pt-2">LeadStream makes it easier to identify companies that fulfil your project
          specifications.</p>
      </div>
    </div>
    <div className="pt-3">
      <div className="row">
        <div class="d-flex flex-wrap justify-content-between">
          <div class="col-12 col-md-4">
            <div class="card p-4 m-4 rounded-4 border-0 shadow-sm">
              <button type="button" className="btn text-start">
                <h4>Development</h4>
              </button>
              <ul class="list-group">
                 <li class="list-group-item border-0"><a className="text-decoration-none" href="/directory/mobile-application-developers">Mobile App
                    Development</a></li>
                 <li class="list-group-item border-0"><a className="text-decoration-none"href="/developers">Software Development</a></li>
                 <li class="list-group-item border-0"><a className="text-decoration-none"href="/web-developers">Web Development</a></li>
                 <li class="list-group-item border-0"><a className="text-decoration-none"href="/developers/virtual-reality">AR/VR</a></li>
                 <li class="list-group-item border-0"><a className="text-decoration-none"href="/developers/artificial-intelligence">Artificial Intelligence</a>
                </li>
                 <li class="list-group-item border-0"><a className="text-decoration-none"href="/developers/blockchain">Blockchain</a></li>
              </ul>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="card p-4 m-4 rounded-4 border-0 shadow-sm">
              <button type="button" className="btn text-start">
                <h4>Design &amp; Production</h4>
              </button>
              <ul class="list-group">
                 <li class="list-group-item border-0"><a className="text-decoration-none"href="/web-designers">Web Design</a></li>
                 <li class="list-group-item border-0"><a className="text-decoration-none"href="/agencies/ui-ux">User Experience Design</a></li>
                 <li class="list-group-item border-0"><a className="text-decoration-none"href="/agencies/logo-designers">Logo Design</a></li>
                 <li class="list-group-item border-0"><a className="text-decoration-none"href="/agencies/graphic-designers">Graphic Design</a></li>
                 <li class="list-group-item border-0"><a className="text-decoration-none"href="/agencies/design">Design</a></li>
                 <li class="list-group-item border-0"><a className="text-decoration-none"href="/agencies/digital-design">Digital Design</a></li>
              </ul>
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div class="card p-4 m-4 rounded-4 border-0 shadow-sm">
              <button type="button" className="btn text-start">
                <h4>Marketing</h4>
              </button>
              <ul class="list-group">
                 <li class="list-group-item border-0"><a className="text-decoration-none"href="/agencies/digital-marketing">Digital Marketing</a></li>
                 <li class="list-group-item border-0"><a className="text-decoration-none"href="/seo-firms">SEO</a></li>
                 <li class="list-group-item border-0"><a className="text-decoration-none"href="/agencies/social-media-marketing">Social Media Marketing</a></li>
                 <li class="list-group-item border-0"><a className="text-decoration-none"href="/agencies/app-marketing">Mobile Marketing</a></li>
                 <li class="list-group-item border-0"><a className="text-decoration-none"href="/agencies/content-marketing">Content Marketing</a></li>
                 <li class="list-group-item border-0"><a className="text-decoration-none"href="/agencies/sem">Search Marketing</a></li>
              </ul>
            </div>
          </div>
          </div>
          <div class="d-flex flex-wrap justify-content-between mt-2">
            <div class="col-12 col-md-4">
              <div class="card p-4 m-4 rounded-4 border-0 shadow-sm">
                <button type="button" className="btn text-start">
                  <h4>Advertising</h4>
                </button>
                <ul class="list-group">
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/agencies">Advertising</a></li>
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/agencies/branding">Branding</a></li>
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/agencies/creative">Creative</a></li>
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/agencies/video-production">Video Production</a></li>
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/pr-firms">Public Relations</a></li>
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/agencies/media-buying">Media Planning &amp; Buying</a></li>
                </ul>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="card p-4 m-4 rounded-4 border-0 shadow-sm">
                <button type="button" className="btn text-start">
                  <h4>Comapany Services</h4>
                </button>
                <ul class="list-group">
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/call-centers">Call Centers</a></li>
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/bpo">BPO</a></li>
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/accounting">Accounting</a></li>
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/real-estate">Commercial Real Estate</a></li>
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/hr">HR Services</a></li>
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/consulting">Consulting</a></li>
                </ul>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="card p-4 m-4 rounded-4 border-0 shadow-sm">
                <button type="button" className="btn text-start">
                  <h4>IT Services</h4>
                </button>
                <ul class="list-group">
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/it-services">IT Services</a></li>
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/it-services/cybersecurity">Cybersecurity</a></li>
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/it-services/analytics">Data Analytics</a></li>
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/it-services/msp">Managed IT Services</a></li>
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/it-services/cloud">Cloud Consulting</a></li>
                   <li class="list-group-item border-0"><a className="text-decoration-none"href="/it-services/staff-augmentation">Staff Augmentation</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


      <div className="container py-5">
        <div className="row py-5 align-items-center justify-content-center">

<div className="col-md-6 col-lg-6 col-xl-6 text-start mb-4 pe-md-5 px-lg-2">
    <img src={BrandImg} alt="Adobe Image" className="img-fluid w-100" />
</div>

                <div className="col-md-6 col-lg-6 col-xl-6">
                <div className="col-12 p-4">
        <h2 className="text-start display-6 fw-semibold">Build Your Brand</h2>
          <p className="fs-5 pt-2">Build credibility and visibility with a free profile on LeadStream and Capterra.</p>
          </div>
                <ul class="list-group p-0 m-0 ms-4">
  <li class="list-group-item p-4 d-flex justify-content-between border-0 align-items-start">
    <div class="ms-2 me-auto">
      <h4 class="fw-600">Free Visibility</h4>
      <p className="p-0 m-0">Create a profile and appear on LeadStream lists.</p>
    </div>
  </li>
  <li class="list-group-item p-4 d-flex justify-content-between border-0 align-items-start">
    <div class="ms-2 me-auto">
      <h4 class="fw-600">Increased Visibility</h4>
      <p className="p-0 m-0">List placement above any free & unclaimed profiles.</p>
    </div>
  </li>
  <li class="list-group-item p-4 d-flex justify-content-between border-0 align-items-start">
    <div class="ms-2 me-auto">
      <h4 class="fw-600">Expanded Profile</h4>
      <p className="p-0 m-0">Showcase more of your work and awards to prospective buyers.</p>
    </div>
  </li>

  <li class="list-group-item p-4 d-flex justify-content-between border-0 align-items-start">
    <div class="ms-2 me-auto">
      <h4 class="fw-600">Review Management</h4>
      <p className="p-0 m-0">View, manage, and respond to your reviews—all through the UpCity platform.</p>
    </div>
  </li>
</ul>

                </div>
            </div>


      </div>
    </div>



    <div className="bg-light pt-5">
          <div className="container-md pb-5">
          <div className="justify-content-center text-center row mt-4">
            <div className="col-lg-12 col-xl-6">
        <h2 className="text-center display-6 fw-semibold">FAQ'S</h2>
          <p className="fs-5 pt-2">Got a question to ask us? Use the list below to find answers to our most frequently asked questions.</p>
        </div>
        </div>
<div class="row justify-content-center text-start">
<div class="col-sm-12 col-lg-12 col-xl-9">
<div className="accordion my-4" id="accordionExample">
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingOne">
      <button
        className="accordion-button py-4 py-4"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseOne"
        aria-expanded="true"
        aria-controls="collapseOne"
      >
        What is the purpose of this platform?
      </button>
    </h2>
    <div
      id="collapseOne"
      className="accordion-collapse collapse show"
      aria-labelledby="headingOne"
      data-bs-parent="#accordionExample"
    >
      <div className="accordion-body">
        Our platform connects employers with talented candidates. It simplifies the hiring process by offering advanced tools for job posting, candidate screening, and communication.
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingTwo">
      <button
        className="accordion-button py-4 collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseTwo"
        aria-expanded="false"
        aria-controls="collapseTwo"
      >
        How do I post a job?
      </button>
    </h2>
    <div
      id="collapseTwo"
      className="accordion-collapse collapse"
      aria-labelledby="headingTwo"
      data-bs-parent="#accordionExample"
    >
      <div className="accordion-body">
        To post a job, simply create an account, navigate to the job posting section, and fill in the required details about the job and your company. Your job will be visible to potential candidates immediately.
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingThree">
      <button
        className="accordion-button py-4 collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseThree"
        aria-expanded="false"
        aria-controls="collapseThree"
      >
        Can I filter candidates?
      </button>
    </h2>
    <div
      id="collapseThree"
      className="accordion-collapse collapse"
      aria-labelledby="headingThree"
      data-bs-parent="#accordionExample"
    >
      <div className="accordion-body">
        Yes, our platform provides various filters to help you find the best candidates based on skills, experience, location, and more.
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingFour">
      <button
        className="accordion-button py-4 collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseFour"
        aria-expanded="false"
        aria-controls="collapseFour"
      >
        How do I purchase jobs or CV Database access online?
      </button>
    </h2>
    <div
      id="collapseFour"
      className="accordion-collapse collapse"
      aria-labelledby="headingFour"
      data-bs-parent="#accordionExample"
    >
      <div className="accordion-body">
        To purchase jobs or CV Database access, log in to your account, navigate to the purchase section, and select the package that best fits your needs. Follow the prompts to complete the payment process.
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingFive">
      <button
        className="accordion-button py-4 collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseFive"
        aria-expanded="false"
        aria-controls="collapseFive"
      >
        How do I log in as a recruiter?
      </button>
    </h2>
    <div
      id="collapseFive"
      className="accordion-collapse collapse"
      aria-labelledby="headingFive"
      data-bs-parent="#accordionExample"
    >
      <div className="accordion-body">
        To log in as a recruiter, go to the login page, enter your recruiter credentials (email and password), and click the "Log In" button. If you don’t have an account, you can register by clicking on the "Sign Up" button.
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header" id="headingSix">
      <button
        className="accordion-button py-4 collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapseSix"
        aria-expanded="false"
        aria-controls="collapseSix"
      >
        I have forgotten my password or am having trouble logging in.
      </button>
    </h2>
    <div
      id="collapseSix"
      className="accordion-collapse collapse"
      aria-labelledby="headingSix"
      data-bs-parent="#accordionExample"
    >
      <div className="accordion-body">
        If you have forgotten your password or are having trouble logging in, click the "Forgot Password" link on the login page. Follow the instructions to reset your password. If you continue to have issues, contact support for assistance.
      </div>
    </div>
  </div>

  </div>
  </div>
</div>
</div>
</div>

<Footer />


</>

  );
};
export default LandingPage;
